import { useEffect, useState } from "react";
import {
  ParsersPanel,
  RejectionStatsResponse,
} from "../../../api/ParsersPanel";
import { useUserState } from "../../../store/user/hooks";

interface State {
  data: RejectionStatsResponse | null;
  loading: boolean;
  error: string | null;
}

export function useRejectionStats(
  node: "tamrur" | "arabic",
  days = 30,
): State {
  const { token } = useUserState();

  const [state, setState] = useState<State>({
    data: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    if (!token) return;

    setState((s) => ({
      ...s,
      loading: true,
      error: null,
    }));

    ParsersPanel.getRejectionStats(token, node, days)
      .then((data) =>
        setState({
          data,
          loading: false,
          error: null,
        })
      )
      .catch((err) => {
        const msg =
          err?.response?.data?.error ||
          err?.message ||
          "Failed to load rejection stats";

        setState({
          data: null,
          loading: false,
          error: msg,
        });
      });
  }, [token, node, days]);

  return state;
}
